const normalizeKey = (key) =>
  key.replace('./', '').replace('.svg', '').replace(/_/g, '-');

const importSvgIcons = (context) => {
  let icons = {};
  context.keys().forEach((key) => {
    icons[normalizeKey(key)] = context(key).default;
  });
  return icons;
};

export default importSvgIcons;
